import DEFAULT_META_TAGS from '@/constants/meta'
import { useRouter } from 'next/router'

export default function useCanonicalUrl() {
  const { asPath } = useRouter()
  const canonicalUrl = `${DEFAULT_META_TAGS.url}${asPath}`.split('?')[0]
  return canonicalUrl
}
